import { helper } from '@ember/component/helper';
import { TaxRateType } from 'uplisting-frontend/models/tax';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { type GenericChangeset } from 'uplisting-frontend/services/repositories/-base';

type ModelWithTax =
  | ModelRegistry['upsell']
  | ModelRegistry['additional-booking-charge'];

function getPriceWithTax([item, field]: [
  GenericChangeset<ModelWithTax> | ModelWithTax,
  string,
]): number {
  const price = Number(item[field || 'price']);
  const { tax } = item;

  if (!tax?.id || tax.rateType === TaxRateType.inclusive) {
    return price;
  }

  const taxAmount = (price * tax.rate) / 100;

  return price + taxAmount;
}

export default helper(getPriceWithTax);
